import { useState } from 'react';
import SearchResults from '../search-results/SearchResults';
import { SearchComponentProps } from './types';

const SearchComponent = ({
  onClose,
  className,
  query,
  setQuery,
  isOpen,
}: SearchComponentProps) => {
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [isExpanded, setIsExpanded] = useState(false); // 👈 new state

  return (
    <div className={className}>
      {/* Wrapper to take full height and prevent body scroll */}
      <div
        className={`scr flex overflow-hidden transition-[height] duration-300 ease-in-out ${
          isExpanded ? 'h-[70vh]' : 'h-[50vh]'
        } md:h-[70vh]`}
      >
        {/* Scrollable Middle Search Results Section */}
        <div className="flex max-h-[120vh] w-full flex-col justify-between overflow-y-auto rounded-2xl">
          <SearchResults
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
            query={query}
            setQuery={setQuery}
            onClose={onClose}
            setIsExpanded={setIsExpanded}
            isOpen={isOpen}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchComponent;
